import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-weave-currency',
    templateUrl: './weave-currency.component.html',
    styleUrls: ['./weave-currency.component.scss'],
    standalone: false
})
export class WeaveCurrencyComponent implements OnInit {
  @Input() data: string;
  @Input() label: string = "";
  @Input() description: string = "";
  @Input() placeholder: string = "";
  @Input() disabledFlag: boolean;
  @Input() showError: boolean = false;
  @Input() required: boolean = false;
  @Output() focusOut: EventEmitter<string> = new EventEmitter<string>();
  tempValue: string = "";
  message: string = "";
  id: string = "";
  constructor() {}

  ngOnInit() {
    if(!this.data) {
      this.data = '0';
    }
    this.id = "weave-currency" + Math.floor(Math.random() * 1000);
    this.message = this.label;
    if(this.message.length > 30 || this.message.length == 0) {
      this.message = "This field";
    }
  }

  onFocusOut() {
    this.showError = false;
    this.focusOut.emit(this.data);
  }

  startEdit() {
    this.tempValue = this.data;
  }

  undo() {
    this.data = this.tempValue;
  }
}
